import Box from "@/components/Box";

export function ReportListCardDescription({ shortDescription, color = "dark" }) {
  if (!shortDescription) {
    return null;
  }

  return (
    <Box fontSize={[14, 14, 16]} fontFamily="gilroyMedium" mt={16} color={color}>
      {shortDescription}
    </Box>
  );
}
